"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(textFormat) {
  switch (textFormat) {
    case 'plain':
      return 'text/plain';

    case 'xml':
      return 'text/xml';

    default:
      return 'text/markdown';
  }
}